import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const AGB = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen text-white" style={{ backgroundColor: '#0a0a0a' }}>
      {/* Header */}
      <nav className="px-6 lg:px-12 py-6 border-b border-white/10">
        <div className="flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-2">
            <img src="/revocut-logo.png" alt="RevoCut" className="w-10 h-10" />
            <span className="text-xl font-bold" style={{ fontFamily: 'Montserrat, sans-serif' }}>REVOCUT</span>
          </button>
          <button 
            onClick={() => navigate(-1)}
            className="text-sm text-gray-400 hover:text-white transition-colors flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück
          </button>
        </div>
      </nav>

      {/* Content */}
      <main className="px-6 lg:px-12 py-12 max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-bold mb-8" style={{ fontFamily: 'Montserrat, sans-serif' }}>
          Allgemeine Geschäftsbedingungen (AGB)
        </h1>

        <div className="prose prose-invert max-w-none space-y-6 text-gray-300">
          <p className="text-lg">
            Stand: März 2026
          </p>

          <section className="space-y-4">
            <h2 className="text-xl font-bold text-white">§ 1 Geltungsbereich</h2>
            <p>
              (1) Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge zwischen RevoCut 
              (nachfolgend "Anbieter") und dem Kunden über die Vermittlung von Freelancer-Dienstleistungen 
              im Bereich Video-Postproduktion.
            </p>
            <p>
              (2) Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, der Anbieter 
              stimmt ihrer Geltung ausdrücklich schriftlich zu.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-bold text-white">§ 2 Vertragsgegenstand</h2>
            <p>
              (1) Der Anbieter vermittelt Freelancer für Video-Postproduktion, einschließlich aber nicht 
              beschränkt auf: Videoschnitt, Motion Design, Color Grading, Sound Design und verwandte 
              Dienstleistungen.
            </p>
            <p>
              (2) Der konkrete Leistungsumfang ergibt sich aus der jeweiligen Projektbeschreibung und 
              dem vereinbarten Angebot.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-bold text-white">§ 3 Vertragsschluss</h2>
            <p>
              (1) Die Darstellung der Dienstleistungen auf unserer Website stellt kein rechtlich 
              bindendes Angebot dar, sondern eine Aufforderung zur Abgabe eines Angebots.
            </p>
            <p>
              (2) Der Vertrag kommt zustande, wenn der Anbieter das Angebot des Kunden durch eine 
              Auftragsbestätigung per E-Mail annimmt.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-bold text-white">§ 4 Preise und Zahlung</h2>
            <p>
              (1) Alle Preise verstehen sich in Euro und beinhalten die gesetzliche Mehrwertsteuer, 
              sofern nicht anders angegeben.
            </p>
            <p>
              (2) Die Zahlung erfolgt per Überweisung oder über den angebotenen Zahlungsdienstleister 
              (Stripe) nach Rechnungsstellung.
            </p>
            <p>
              (3) Sofern nicht anders vereinbart, ist der Rechnungsbetrag innerhalb von 14 Tagen nach 
              Rechnungsdatum fällig.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-bold text-white">§ 5 Lieferung und Leistungserbringung</h2>
            <p>
              (1) Der Liefertermin wird individuell vereinbart und im Angebot festgehalten.
            </p>
            <p>
              (2) Die Lieferung der fertigen Videodateien erfolgt digital über einen vom Anbieter 
              bereitgestellten Download-Link.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-bold text-white">§ 6 Mitwirkungspflichten des Kunden</h2>
            <p>
              (1) Der Kunde stellt das erforderliche Rohmaterial rechtzeitig und in geeigneter 
              Qualität zur Verfügung.
            </p>
            <p>
              (2) Der Kunde erteilt zeitnah Feedback und Freigaben, um einen reibungslosen 
              Projektablauf zu gewährleisten.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-bold text-white">§ 7 Gewährleistung</h2>
            <p>
              (1) Der Anbieter erbringt seine Leistungen mit größter Sorgfalt und nach dem 
              aktuellen Stand der Technik.
            </p>
            <p>
              (2) Mängelansprüche verjähren innerhalb eines Jahres nach Abnahme der Leistung.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-bold text-white">§ 8 Haftung</h2>
            <p>
              (1) Der Anbieter haftet unbeschränkt für Schäden aus der Verletzung des Lebens, 
              des Körpers oder der Gesundheit sowie für vorsätzlich oder grob fahrlässig 
              verursachte Schäden.
            </p>
            <p>
              (2) Für leicht fahrlässig verursachte Schäden haftet der Anbieter nur bei Verletzung 
              wesentlicher Vertragspflichten, begrenzt auf den vorhersehbaren, vertragstypischen Schaden.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-bold text-white">§ 9 Urheberrecht</h2>
            <p>
              (1) Mit vollständiger Bezahlung gehen die Nutzungsrechte am erstellten Videomaterial 
              auf den Kunden über.
            </p>
            <p>
              (2) Der Anbieter behält sich das Recht vor, die erstellten Arbeiten für 
              Referenzzwecke zu verwenden, sofern der Kunde nicht ausdrücklich widerspricht.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-bold text-white">§ 10 Datenschutz</h2>
            <p>
              Die Verarbeitung personenbezogener Daten erfolgt gemäß unserer Datenschutzerklärung, 
              die auf unserer Website einsehbar ist.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-bold text-white">§ 11 Schlussbestimmungen</h2>
            <p>
              (1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des 
              UN-Kaufrechts.
            </p>
            <p>
              (2) Gerichtsstand ist, soweit gesetzlich zulässig, der Sitz des Anbieters.
            </p>
            <p>
              (3) Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit 
              der übrigen Bestimmungen unberührt.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-bold text-white">Kontakt</h2>
            <p>
              RevoCut<br />
              E-Mail: info@revocut-media.de<br />
              Website: www.revocut-media.de
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default AGB;
